/* =====================================================================
   Domande dell'acquisto: una alla volta - 29 AGO 2026

   Il lavoro lo fa gia' il browser, con l'attributo name sulle <details>:
   voci con lo stesso nome sono un gruppo, e aprendone una si chiude
   quella aperta prima. Questo file serve solo ai browser che quel
   comportamento non ce l'hanno ancora.

   Per questo la prima cosa che fa e' chiedersi se serve: se il browser
   sa gia' fare da solo, esce e non aggancia niente.
   ===================================================================== */
(function () {
  var voci = document.querySelectorAll('details.ab-dom__voce[name]');
  if (!voci.length) return;

  /* prova del nove: si crea una <details> con name e si guarda se il
     browser espone quella proprieta. Se la espone, il gruppo lo gestisce
     lui e qui non c'e altro da fare. */
  var prova = document.createElement('details');
  if ('name' in prova) return;

  for (var i = 0; i < voci.length; i++) {
    voci[i].addEventListener('toggle', function () {
      if (!this.open) return;
      var gruppo = this.getAttribute('name');
      for (var k = 0; k < voci.length; k++) {
        if (voci[k] !== this && voci[k].getAttribute('name') === gruppo) {
          voci[k].open = false;
        }
      }
    });
  }
})();
